/** The formats the backend decodes; anything else is rejected on upload. */
export const SUPPORTED_IMAGE_MIME_TYPES = ['image/jpeg', 'image/png', 'image/webp'] as const

export function extensionFor(mimeType: string): string {
  return mimeType.split('/')[1] ?? 'png'
}

export async function urlToFile(url: string, filename: string): Promise<File> {
  const res = await fetch(url)
  if (!res.ok) throw new Error(`Failed to load image (${res.status})`)
  const blob = await res.blob()
  return new File([blob], filename, { type: blob.type })
}
